export default {
  actionFilters: [
    { name: 'CREATE' },
    { name: 'UPDATE' },
    { name: 'DELETE' },
  ],
  statusFilters: [
    { name: 'ERROR' },
    { name: 'SUCCESS' },
  ],
  originFilters: [
    {
      name: 'Gerenciar usuários',
      whatChangedFilters: [
        { name: 'Usuário' },
        { name: 'Ativar/Desativar' },
        { name: 'Bloquear/Desbloquear' },
        { name: 'Alterar Senha' },
      ],
    },
    {
      name: 'Regras de Cotação',
      whatChangedFilters: [
        {
          name: 'Regra de Cotação',
        },
        {
          name: 'Ativar/Desativar',
        },
        {
          name: 'Alterar Prioridade',
        },
      ],
    },
    {
      name: 'Minhas Transportadoras',
      whatChangedFilters: [
        {
          name: 'Transportadora',
        },
        {
          name: 'Contrato',
        },
        {
          name: 'Ativar/Desativar',
        },
        {
          name: 'Dados do SIGEP',
        },
      ],
    },
    {
      name: 'Pedidos',
      whatChangedFilters: [
        {
          name: 'Entrega prev.',
        },
        {
          name: 'Entrega prev. (Transp)',
        },
      ],
    },
    {
      name: 'Centros de Distribuição',
      whatChangedFilters: [
        {
          name: 'Centro de Distribuição',
        },
        {
          name: 'Configurar transportadora',
        },
      ],
    },
    {
      name: 'Grupos de produtos',
      whatChangedFilters: [
        {
          name: 'Grupo de Produto',
        },
      ],
    },
    {
      name: 'Embalagens',
      whatChangedFilters: [
        {
          name: 'Embalagem',
        },
        {
          name: 'Ativar/Desativar',
        },
      ],
    },
    {
      name: 'Informações da empresa',
      whatChangedFilters: [
        {
          name: 'Empresa',
        },
      ],
    },
    {
      name: 'Configuração de Segurança',
      whatChangedFilters: [
        {
          name: 'Segurança',
        },
      ],
    },
  ],
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-analytic/features/logs/pages/user/enum/logsUserFilters.enum.js